import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { motion, Transition } from "framer-motion";
import React from "react";
import CheckBoldIcon from "../../public/icons/check-bold";
import CreditCardIcon from "../../public/icons/creditCard";
import StopLogoIcon from "../../public/icons/stop-logo";
import AddPairIcon from "../assets/icon/add-pair";
import ApplyIcon from "../assets/icon/apply";
import ArchiveIcon from "../assets/icon/archive";
import ArrowIcon from "../assets/icon/arrow";
import ArrowDownIcon from "../assets/icon/arrow-down";
import ArrowDownFooterIcon from "../assets/icon/arrow-down-footer";
import ArrowLeftGreyIcon from "../assets/icon/arrow-left-grey";
import ArrowRightIcon from "../assets/icon/arrow-right";
import ArrowRightGreyIcon from "../assets/icon/arrow-right-grey";
import ArrowUpIcon from "../assets/icon/arrow-up";
import AssignLabelIcon from "../assets/icon/assign-label";
import AssignLabelGreyIcon from "../assets/icon/assign-label-grey";
import BellIcon from "../assets/icon/bell";
import CalendarIcon from "../assets/icon/calendar";
import CampaignIcon from "../assets/icon/campaign";
import CampaignEmptydIcon from "../assets/icon/campaign-empty";
import ChecklistIcon from "../assets/icon/CampaignNotesToolbar/checklist-icon";
import OutdentIcon from "../assets/icon/CampaignNotesToolbar/outdent-icon";
import FormatTextIcon from "../assets/icon/CampaignNotesToolbar/format-text-icon";
import IndentIcon from "../assets/icon/CampaignNotesToolbar/indent-icon";
import ItalicIcon from "../assets/icon/CampaignNotesToolbar/italic-icon";
import JustifyTextIcon from "../assets/icon/CampaignNotesToolbar/align-left-icon";
import LinkAttachIcon from "../assets/icon/CampaignNotesToolbar/link-attach-icon";
import QuoteIcon from "../assets/icon/CampaignNotesToolbar/quote-icon";
import StrikethroughIcon from "../assets/icon/CampaignNotesToolbar/strikethrough-icon";
import UnderlineIcon from "../assets/icon/CampaignNotesToolbar/underline-icon";
import BoldIcon from "../assets/icon/CampaignNotesToolbar/bold-icon";
import Campaigns from "../assets/icon/campaigns";
import CaretDownIcon from "../assets/icon/caret-down";
import CheckIcon from "../assets/icon/check";
import CheckCircleIcon from "../assets/icon/check-circle";
import CheckedCircleIcon from "../assets/icon/checked-circle";
import ClicksIcon from "../assets/icon/clicks";
import CloneIcon from "../assets/icon/clone";
import CloseCircleIcon from "../assets/icon/close-circle";
import CloseEmailIcon from "../assets/icon/close-email";
import CloseEmailEnvelopeIcon from "../assets/icon/close-email-envelope";
import CloseModalIcon from "../assets/icon/close-modal";
import CloseOrangeIcon from "../assets/icon/close-orange";
import ContactsSelectedIcon from "../assets/icon/contact-selected";
import Contacts from "../assets/icon/contacts";
import ContentIcon from "../assets/icon/content";
import CsvIcon from "../assets/icon/csv";
import CustomCopyIcon from "../assets/icon/custom-copy";
import Dashboard from "../assets/icon/dashboard";
import DelayIcon from "../assets/icon/delay";
import DeleteIcon from "../assets/icon/delete";
import DisconnectIcon from "../assets/icon/disconnect";
import DuplicateIcon from "../assets/icon/duplicate";
import DuplicateOrangeIcon from "../assets/icon/duplicate-orange";
import EditIcon from "../assets/icon/edit";
import EmailEmptydIcon from "../assets/icon/email-empty";
import EmailSettingsIcon from "../assets/icon/email-settings";
import EmailShadowIcon from "../assets/icon/email-shadow";
import Emails from "../assets/icon/emails";
import EyeIcon from "../assets/icon/eye";
import EyeSlashIcon from "../assets/icon/eye-slash";
import FaTrashAltIcon from "../assets/icon/fa-trash-alt";
import FavoriteIcon from "../assets/icon/favorite";
import FavoriteFilledIcon from "../assets/icon/favorite-filled";
import FilterIcon from "../assets/icon/filter";
import FormIcon from "../assets/icon/form";
import Forms from "../assets/icon/forms";
import FragmentIcon from "../assets/icon/fragment-icon";
import FriendsIcon from "../assets/icon/friends";
import GraphicIcon from "../assets/icon/graphic";
import InfoIcon from "../assets/icon/info";
import InformationCircleIcon from "../assets/icon/information-circle";
import LessIcon from "../assets/icon/less";
import LessZoomIcon from "../assets/icon/less-zoom";
import MenuIcon from "../assets/icon/menu";
import MessageIcon from "../assets/icon/message";
import MinusIcon from "../assets/icon/minus";
import MoreIcon from "../assets/icon/more";
import MoreZoomIcon from "../assets/icon/more-zoom";
import NavigationArrowRightIcon from "../assets/icon/navigation-arrow-right";
import New from "../assets/icon/new";
import NoResultsFoundIcon from "../assets/icon/no-results-found";
import NoteIcon from "../assets/icon/note";
import NoteEmptyIcon from "../assets/icon/note-empty";
import OpensIcon from "../assets/icon/opens";
import OverviewIcon from "../assets/icon/overview";
import PenIcon from "../assets/icon/pen";
import PencilIcon from "../assets/icon/pencil";
import PlusIcon from "../assets/icon/plus";
import PreviewIcon from "../assets/icon/preview";
import RecipientsIcon from "../assets/icon/recipients";
import RemoveIcon from "../assets/icon/remove";
import RemovePairIcon from "../assets/icon/remove-pair";
import ResendIcon from "../assets/icon/resend";
import ResetIcon from "../assets/icon/reset";
import SaveIcon from "../assets/icon/save";
import SearchIcon from "../assets/icon/search";
import SettingsIcon from "../assets/icon/settings";
import SignoutIcon from "../assets/icon/signout";
import SMSIcon from "../assets/icon/sms";
import SquareIcon from "../assets/icon/square";
import StartCampaignIcon from "../assets/icon/start-campaign";
import StartTagIcon from "../assets/icon/start-tag";
import StopwatchIcon from "../assets/icon/stopwatch";
import TagIcon from "../assets/icon/tag";
import TagEmptydIcon from "../assets/icon/tag-empty";
import TagOutlinedIcon from "../assets/icon/tag-outlined";
import ThreedotsIcon from "../assets/icon/threedots";
import ThreelinesIcon from "../assets/icon/threelines";
import TimeIcon from "../assets/icon/time";
import TourIcon from "../assets/icon/tour";
import TrashIcon from "../assets/icon/trash";
import TurnsOffIcon from "../assets/icon/turns-off";
import Unsubscribe from "../assets/icon/unsubscribe";
import UnsubscribersIcon from "../assets/icon/unsubscribers";
import UploadIcon from "../assets/icon/upload";
import WebHookIcon from "../assets/icon/webhook";
import BerserkerLogo from "../assets/images/berserker-logo";
import ContactIcon from "../assets/images/contact";
import EmailCalendarImage from "../assets/images/email-calendar";
import PageImage from "../assets/images/page";
import TagsFolderImage from "../assets/images/tags-folder";
import WebFormsEmptyImg from "../assets/images/webforms-empty";
import HorizontalSeparatorIcon from "../assets/icon/CampaignNotesToolbar/align-left-icon";
import AlignLeftIcon from "../assets/icon/CampaignNotesToolbar/align-left-icon";

type Icons = { [iconName: string]: JSX.Element };
type ElementType<T extends ReadonlyArray<unknown>> = T extends ReadonlyArray<
  infer IconName
>
  ? IconName
  : never;

type IconName = ElementType<typeof iconsName>;

const Icon = styled.div<{ hoverColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  :hover {
    path {
      ${(props) =>
        props.hoverColor &&
        css`
          fill: ${props.hoverColor};
        `}
    }
  }
`;

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}
interface Props {
  name: IconName;
  width?: number;
  height?: number;
  color?: string;
  hoverColor?: string;
  isLoading?: boolean;
}

export const iconsName = [
  "apply",
  "arrow",
  "arrow-down",
  "arrow-down-footer",
  "arrow-up",
  "arrowleftgrey",
  "arrowright",
  "arrowrightgrey",
  "assignlabel",
  "assignlabelgrey",
  "berserker-logo",
  "calendar",
  "caret-down",
  "campaign-empty",
  "check",
  "checkCircle",
  "clicks",
  "close-email",
  "close-email-envelope",
  "close-modal",
  "close-orange",
  "contact",
  "contacts-selected",
  "content",
  "custom-copy",
  "csv",
  "delete",
  "duplicate",
  "edit",
  "eye",
  "email-settings",
  "email-empty",
  "eye-slash",
  "email-calendar",
  "email-shadow",
  "favorite",
  "favoriteFilled",
  "fa-trash-alt",
  "filter",
  "fragment-icon",
  "friends",
  "graphic",
  "info",
  "less",
  "less-zoom",
  "message",
  "menu",
  "minus",
  "more",
  "more-zoom",
  "navigation-arrow-right",
  "noResultsFound",
  "note",
  "note-empy",
  "opens",
  "overview",
  "page",
  "plus",
  "preview",
  "recipients",
  "remove",
  "resend",
  "save",
  "search",
  "settings",
  "signout",
  "square",
  "start-campaign",
  "start-tag",
  "stopwatch",
  "tag",
  "tag-empty",
  "tag-outlined",
  "tagsFolder",
  "trash",
  "threedots",
  "threelines",
  "time",
  "tour",
  "unsubscribers",
  "upload",
  "reset",
  "pen",
  "checked-circle",
  "closed-circle",
  "information-circle",
  "turns-off",
  "sms",
  "bell",
  "webhook",
  "delay",
  "add-pair",
  "remove-pair",
  "clone",
  "archive",
  "form",
  "campaign",
  "unsubscribe",
  "pencil",
  "duplicate-orange",
  "webforms-empty",
  "disconnect",
  "format-text-icon",
  "checklist-icon",
  "justify-text-icon",
  "link-attach-icon",
  "quote-icon",
  "indent-icon",
  "outdent-icon",
  "centralize-text-icon",
  "bold-icon",
  "italic-icon",
  "underline-icon",
  "strikethrough-icon",
];

const CircleLoading = styled.div`
  position: relative;
  width: 21px;
  height: 23px;
  box-sizing: border-box;
`;

const CircleStyle = styled(motion.span)`
  display: block;
  width: 1.5rem;
  height: 1.5rem;
  border: 0.2rem solid #e9e9e9;
  border-top: 0.2rem solid #5fa200;
  border-radius: 50%;
  position: absolute;
  box-sizing: border-box;
  top: 0;
  left: 0;
`;

const spinTransition: Transition = {
  repeatType: "loop",
  ease: "linear",
  duration: 1,
  repeat: Infinity,
};

export function LoadingComponent(): JSX.Element {
  return (
    <CircleLoading>
      <CircleStyle animate={{ rotate: 360 }} transition={spinTransition} />
    </CircleLoading>
  );
}

export default function IconBerserkerMail(props: Props): JSX.Element {
  const { name, width, height, color, hoverColor, isLoading } = props;

  if (isLoading)
    return (
      <CircleLoading>
        <CircleStyle animate={{ rotate: 360 }} transition={spinTransition} />
      </CircleLoading>
    );

  const iconsMap: Icons = {
    apply: <ApplyIcon width={width} height={height} color={color} />,
    arrow: <ArrowIcon width={width} height={height} color={color} />,
    "arrow-down": <ArrowDownIcon width={width} height={height} color={color} />,
    "arrow-down-footer": (
      <ArrowDownFooterIcon width={width} height={height} color={color} />
    ),
    "arrow-up": <ArrowUpIcon width={width} height={height} color={color} />,
    arrowleftgrey: (
      <ArrowLeftGreyIcon width={width} height={height} color={color} />
    ),
    arrowright: <ArrowRightIcon width={width} height={height} color={color} />,
    arrowrightgrey: (
      <ArrowRightGreyIcon width={width} height={height} color={color} />
    ),
    assignlabel: (
      <AssignLabelIcon width={width} height={height} color={color} />
    ),
    assignlabelgrey: (
      <AssignLabelGreyIcon width={width} height={height} color={color} />
    ),
    "berserker-logo": <BerserkerLogo width={width} height={height} />,
    calendar: <CalendarIcon width={width} height={height} color={color} />,
    "caret-down": <CaretDownIcon width={width} height={height} color={color} />,
    "campaign-empty": (
      <CampaignEmptydIcon width={width} height={height} color={color} />
    ),
    check: <CheckIcon width={width} height={height} color={color} />,
    checkCircle: (
      <CheckCircleIcon width={width} height={height} color={color} />
    ),
    clicks: <ClicksIcon width={width} height={height} color={color} />,
    "close-email": (
      <CloseEmailIcon width={width} height={height} color={color} />
    ),
    "close-email-envelope": (
      <CloseEmailEnvelopeIcon width={width} height={height} color={color} />
    ),
    "close-modal": (
      <CloseModalIcon width={width} height={height} color={color} />
    ),
    "close-orange": (
      <CloseOrangeIcon width={width} height={height} color={color} />
    ),
    contact: <ContactIcon width={width} height={height} color={color} />,
    "contacts-selected": (
      <ContactsSelectedIcon width={width} height={height} color={color} />
    ),
    content: <ContentIcon width={width} height={height} color={color} />,
    "custom-copy": (
      <CustomCopyIcon width={width} height={height} color={color} />
    ),
    csv: <CsvIcon width={width} height={height} color={color} />,
    delete: <DeleteIcon width={width} height={height} color={color} />,
    disconnect: <DisconnectIcon width={width} height={height} />,
    duplicate: <DuplicateIcon width={width} height={height} color={color} />,
    edit: <EditIcon width={width} height={height} color={color} />,
    "email-calendar": (
      <EmailCalendarImage width={width} height={height} color={color} />
    ),
    "email-empty": <EmailEmptydIcon width={width} height={height} />,
    "email-settings": (
      <EmailSettingsIcon width={width} height={height} color={color} />
    ),
    "email-shadow": (
      <EmailShadowIcon width={width} height={height} color={color} />
    ),
    eye: <EyeIcon width={width} height={height} color={color} />,
    "eye-slash": <EyeSlashIcon width={width} height={height} color={color} />,
    favorite: <FavoriteIcon width={width} height={height} color={color} />,
    favoriteFilled: (
      <FavoriteFilledIcon width={width} height={height} color={color} />
    ),
    "fa-trash-alt": (
      <FaTrashAltIcon width={width} height={height} color={color} />
    ),
    filter: <FilterIcon width={width} height={height} color={color} />,
    "fragment-icon": (
      <FragmentIcon width={width} height={height} color={color} />
    ),
    friends: <FriendsIcon width={width} height={height} color={color} />,
    graphic: <GraphicIcon width={width} height={height} color={color} />,
    info: <InfoIcon width={width} height={height} color={color} />,
    less: <LessIcon width={width} height={height} color={color} />,
    "less-zoom": <LessZoomIcon width={width} height={height} color={color} />,
    message: <MessageIcon width={width} height={height} color={color} />,
    menu: <MenuIcon width={width} height={height} color={color} />,
    minus: <MinusIcon width={width} height={height} color={color} />,
    more: <MoreIcon width={width} height={height} color={color} />,
    "more-zoom": <MoreZoomIcon width={width} height={height} color={color} />,
    "navigation-arrow-right": (
      <NavigationArrowRightIcon width={width} height={height} color={color} />
    ),
    note: <NoteIcon width={width} height={height} color={color} />,
    "note-empty": <NoteEmptyIcon width={width} height={height} color={color} />,
    noResultsFound: (
      <NoResultsFoundIcon width={width} height={height} color={color} />
    ),
    opens: <OpensIcon width={width} height={height} color={color} />,
    overview: <OverviewIcon width={width} height={height} color={color} />,
    page: <PageImage width={width} height={height} color={color} />,
    plus: <PlusIcon width={width} height={height} color={color} />,
    preview: <PreviewIcon width={width} height={height} color={color} />,
    recipients: <RecipientsIcon width={width} height={height} color={color} />,
    remove: <RemoveIcon width={width} height={height} color={color} />,
    resend: <ResendIcon width={width} height={height} color={color} />,
    save: <SaveIcon width={width} height={height} color={color} />,
    search: <SearchIcon width={width} height={height} color={color} />,
    settings: <SettingsIcon width={width} height={height} color={color} />,
    signout: <SignoutIcon width={width} height={height} color={color} />,
    square: <SquareIcon width={width} height={height} color={color} />,
    "start-campaign": (
      <StartCampaignIcon width={width} height={height} color={color} />
    ),
    "start-tag": <StartTagIcon width={width} height={height} color={color} />,
    stopwatch: <StopwatchIcon width={width} height={height} color={color} />,
    tag: <TagIcon width={width} height={height} color={color} />,
    "tag-empty": <TagEmptydIcon width={width} height={height} color={color} />,
    "tag-outlined": <TagOutlinedIcon width={width} height={height} />,
    tagsFolder: <TagsFolderImage width={width} height={height} color={color} />,
    trash: <TrashIcon width={width} height={height} color={color} />,
    threedots: <ThreedotsIcon width={width} height={height} color={color} />,
    threelines: <ThreelinesIcon width={width} height={height} color={color} />,
    time: <TimeIcon width={width} height={height} color={color} />,
    tour: <TourIcon width={width} height={height} color={color} />,
    unsubscribers: (
      <UnsubscribersIcon width={width} height={height} color={color} />
    ),
    upload: <UploadIcon width={width} height={height} color={color} />,
    reset: <ResetIcon width={width} height={height} color={color} />,
    pen: <PenIcon width={width} height={height} color={color} />,
    "checked-circle": (
      <CheckedCircleIcon width={width} height={height} color={color} />
    ),
    "closed-circle": (
      <CloseCircleIcon width={width} height={height} color={color} />
    ),
    "information-circle": (
      <InformationCircleIcon width={width} height={height} color={color} />
    ),
    "turns-off": <TurnsOffIcon width={width} height={height} color={color} />,
    sms: <SMSIcon width={width} height={height} color={color} />,
    bell: <BellIcon width={width} height={height} color={color} />,
    webhook: <WebHookIcon width={width} height={height} color={color} />,
    delay: <DelayIcon width={width} height={height} color={color} />,
    "add-pair": <AddPairIcon width={width} height={height} color={color} />,
    "remove-pair": (
      <RemovePairIcon width={width} height={height} color={color} />
    ),
    clone: <CloneIcon width={width} height={height} color={color} />,
    archive: <ArchiveIcon width={width} height={height} color={color} />,
    form: <FormIcon width={width} height={height} color={color} />,
    campaign: <CampaignIcon width={width} height={height} color={color} />,
    new: <New width={width} height={height} color={color} />,
    dashboard: <Dashboard width={width} height={height} color={color} />,
    emails: <Emails width={width} height={height} color={color} />,
    forms: <Forms width={width} height={height} color={color} />,
    campaigns: <Campaigns width={width} height={height} color={color} />,
    contacts: <Contacts width={width} height={height} color={color} />,
    unsubscribe: <Unsubscribe width={width} height={height} color={color} />,
    "stop-logo": <StopLogoIcon width={width} height={height} color={color} />,
    "check-bold": <CheckBoldIcon width={width} height={height} color={color} />,
    pencil: <PencilIcon width={width} height={height} color={color} />,
    "duplicate-orange": <DuplicateOrangeIcon width={width} height={height} />,
    "credit-card": (
      <CreditCardIcon color={color} width={width} height={height} />
    ),
    "webforms-empty": <WebFormsEmptyImg />,
    "format-text-icon": <FormatTextIcon width={width} height={height} />,
    "checklist-icon": <ChecklistIcon width={width} height={height} />,
    "align-left-icon": <AlignLeftIcon width={width} height={height} />,
    "link-attach-icon": <LinkAttachIcon width={width} height={height} />,
    "quote-icon": <QuoteIcon width={width} height={height} />,
    "indent-icon": <IndentIcon width={width} height={height} />,
    "outdent-icon": <OutdentIcon width={width} height={height} />,
    "horizontal-separator-icon": (
      <HorizontalSeparatorIcon width={width} height={height} />
    ),
    "bold-icon": <BoldIcon width={width} height={height} color={color} />,
    "italic-icon": <ItalicIcon width={width} height={height} color={color} />,
    "underline-icon": (
      <UnderlineIcon width={width} height={height} color={color} />
    ),
    "strikethrough-icon": (
      <StrikethroughIcon width={width} height={height} color={color} />
    ),
  };

  return <Icon hoverColor={hoverColor}>{iconsMap[name]}</Icon>;
}
